<template>
  <div class="p-anken-index__btn">
    <a v-if="paging.current_page > 2" href="javascript:void(0);" @click="gotoPage(1)"><<</a>
    <a v-if="paging.current_page > 1" href="javascript:void(0);" @click="gotoPage(paging.current_page-1)"><</a>
    <a href="javascript:void(0);" @click="gotoPage(page)" v-bind:class="{ current: paging.current_page == page}" v-for="page in this.getPages()" :key="page">{{page}}</a>
    <a  v-if="paging.current_page < paging.last_page" href="javascript:void(0);" @click="gotoPage(paging.current_page+1)">></a>
    <a  v-if="paging.current_page < (paging.last_page - 1)" href="javascript:void(0);" @click="gotoPage(paging.last_page)">>></a>
  </div>
</template>

<script>

export default {
  props: {
    paging : {
      type: Array | Object,
      default: [],
      required: true,
    },
    query: String,
    form: String,
    method: String
  },
  components: {
  },
  data() {
    return {
      url: this.paging.path + '?' + this.query.replace(/page=[0-9]/g, "")
    }
  },
  methods: {
    gotoPage(page) {
      if (this.method && this.method.toUpperCase() == 'POST') {
        $('input[name="page"]').val(page)
        $(this.form).submit();
      } else {
        this.redirect(this.url + '&page=' + page)
      }
    },

    getPages() {
      let pages = []
      for (let page = 1; page <= this.paging.last_page; page++) {
        if ((page >= this.paging.current_page - 4 && page <= this.paging.current_page + 5) 
        || (this.paging.current_page < 5 && page <= 10)
        || (page > this.paging.last_page - 10 && this.paging.current_page + 5 > this.paging.last_page)) {
          pages.push(page)
        }
      }

      return pages;
    }
  },
  mounted() {
  },
  computed: {
  }
}
</script>
